import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/Button';
import { BottomModal } from '../../components/shared/BottomModal';
import { useUserService } from '../../services/user.service';
import { toast } from 'react-toastify';
import { openTelegramLink } from '../../utils/openLink';
import { clearAllUserData } from '../../store/userSlice';
import { clearAuthData } from '../../store/authSlice';
import { useDispatch, useSelector } from 'react-redux';

function DeleteProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.auth || {});
  const { deleteAccount } = useUserService();

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteAccount = async () => {
    if (isDeleting) return;
    setIsDeleting(true);

    try {
      await deleteAccount();
      dispatch(clearAllUserData());
      dispatch(clearAuthData());
      try {
        if (userId) {
          localStorage.removeItem(`appFirstLaunch_${userId}`);
        }
        localStorage.removeItem('appFirstLaunch');
        localStorage.removeItem('firstVisit3');
        localStorage.removeItem('userFilters');
        localStorage.removeItem('authState');
        localStorage.removeItem('auth_token');
        console.log('💾 LocalStorage: instruction and related keys cleared after account deletion');
      } catch (e) {
        console.warn('Failed to clear some localStorage keys:', e);
      }
      navigate('/', { replace: true });

      // Показываем сообщение об успешном удалении
      toast.success('Аккаунт успешно удален');
    } catch (error) {
      console.error('Error deleting account:', error);
      toast.error('Произошла ошибка при удалении аккаунта. Попробуйте еще раз.');
      setIsConfirmOpen(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="font-raleway p-4">
      <p className="text-white text-[18px] font-medium">
        Вы уверены? Это навсегда удалит ваши данные. Если вас что-то расстроило, напишите нам — мы готовы быстро всё
        исправить!
      </p>

      <div className="text-black py-[32px] flex flex-col items-center justify-center">
        <Button className="w-full" onClick={() => openTelegramLink('https://t.me/myta_support')}>
          Написать в поддержку
        </Button>
        <button className="text-[18px] text-white pt-[15px] h-[64px] w-full" onClick={() => setIsConfirmOpen(true)}>
          Всё равно хочу удалить
        </button>
      </div>

      <BottomModal isOpen={isConfirmOpen} onClose={() => setIsConfirmOpen(false)}>
        <div className="px-4 text-white overflow-auto">
          <div className="flex flex-col justify-start items-center w-full pb-6">
            <p className="text-center font-semibold text-[18px] mb-32">
              Вы уверены, что хотите удалить свой аккаунт? Это действие невозможно будет отменить
            </p>
            <Button variant="danger" className="w-full" onClick={handleDeleteAccount} disabled={isDeleting}>
              Удалить
            </Button>
            <button
              className="text-[#FFFFFF] opacity-50 mt-[5px] h-16 w-full"
              onClick={() => setIsConfirmOpen(false)}
              disabled={isDeleting}
            >
              Отмена
            </button>
          </div>
        </div>
      </BottomModal>
    </div>
  );
}

export default DeleteProfile;
